import React from 'react';
import { Route, Routes } from 'react-router-dom';
import ListTerms from './list-terms';
import TermsDetail from './terms-detail';
import Header from '../common/components/header';
import Sidebar from '../common/components/sidebar';

const TermsAndConditionsRoutes = () => (
  <>
    <Header />
    <Sidebar />
    <div className="page-wrapper">
      <div className="content">
        <Routes>
          <Route path="/list-terms" element={<ListTerms />} />
          <Route path="/terms-detail/:id" element={<TermsDetail />} />
          <Route path="/" element={<ListTerms />} />
        </Routes>
      </div>
    </div>
  </>
);

export default TermsAndConditionsRoutes; 